import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';

export default function TopicSection() {
  return (
    <section>
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-sparkling-2-line"></i>
        </div>
        <h2 className="text-lg md:text-xl font-bold text-foreground-900">影视专题推荐</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to={`/search?q=${encodeURIComponent(topic.title)}`}
            className="group relative block h-44 md:h-52 rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src={topic.cover}
              alt={`${topic.title} 专题封面`}
              title={topic.title}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
              <h3 className="text-background-50 font-bold text-base md:text-lg">{topic.title}</h3>
              <p className="mt-1 text-xs md:text-sm text-background-200 line-clamp-2">{topic.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}